import { Theme, useTheme } from "@afterpaytouch/core";
import classNames from "classnames/bind";
import Link from "next/link";
import React, { KeyboardEventHandler, MouseEventHandler } from "react";

import type { KIND, SIZE } from "../dropdown-menu.constants";
import { KINDS, SIZES } from "../dropdown-menu.constants";
import { DropdownMenuItem as MenuItem } from "./dropdown-menu-item-interface";
import styles from "./dropdownMenuItem.module.scss";

const cx = classNames.bind(styles);

export type Props = {
    id: number;
    kind: KIND;
    item: MenuItem;
    size?: SIZE;
    onClick?: (item: MenuItem) => void;
};

export const DropdownMenuItem: React.FC<Props> = (props: Props) => {
    const { id, kind, item, size, onClick } = props;
    const { countryIcon, name, link, utc } = item;
    const theme = useTheme();
    const currentTheme = theme.theme.selected;

    const menuItemClassName = cx({
        [styles.dropdownMenuItem]: true,
        [styles[kind]]: true,
        [styles[size]]: size === SIZES.SMALL,
        [styles.arcade]: currentTheme === Theme.Cash,
    });

    const countryIconClassName = cx({
        [styles.countryIcon]: true,
    });

    const utcClassName = cx({
        [styles.utc]: true,
    });

    const TextItem = () => {
        return <span>{name}</span>;
    };

    const CountryItem = () => {
        return (
            <Link prefetch={false} href={link}>
                <span className={countryIconClassName} data-testid="country-icon">
                    {countryIcon}
                </span>
                {name}
                <span className={utcClassName}>{utc}</span>
            </Link>
        );
    };

    const renderMenuItem = () => {
        switch (kind) {
            case KINDS.COUNTRY:
                return <CountryItem />;
            default:
                return <TextItem />;
        }
    };

    const handleClick: MouseEventHandler = () => {
        onClick(item);
    };

    const onKeyDown: KeyboardEventHandler<HTMLLIElement> = (e) => {
        switch (e.key) {
            case "Enter": {
                return onClick(item);
            }
        }
    };

    const MenuItem = () => {
        return (
            <li
                key={id}
                className={menuItemClassName}
                tabIndex={0}
                role="button"
                onClick={handleClick}
                onKeyDown={onKeyDown}
            >
                {renderMenuItem()}
            </li>
        );
    };

    return <MenuItem />;
};
